import axios from 'axios';

const baseUrl = import.meta.env.VITE_API_BASE_URL;

export const login = async (username, password) => {
  const res = await axios.post(`${baseUrl}/auth/login`, { username, password });
  return res.data.user;
};

// Users & roles management
export const fetchUsers = async () => (await axios.get(`${baseUrl}/users`)).data || [];
export const createUser = (v) => axios.post(`${baseUrl}/users`, v);
export const updateUser = (id, v) => axios.put(`${baseUrl}/users/${id}`, v);
export const deleteUser = (id) => axios.delete(`${baseUrl}/users/${id}`);

export const fetchRoles = async () => (await axios.get(`${baseUrl}/roles`)).data || [];
export const createRole = (v) => axios.post(`${baseUrl}/roles`, v);
export const updateRole = (id, v) => axios.put(`${baseUrl}/roles/${id}`, v);
export const deleteRole = (id) => axios.delete(`${baseUrl}/roles/${id}`);
